import React from "react";
import { Button as ChakraButton, ButtonProps } from "@chakra-ui/button";
import { forwardRef } from "@chakra-ui/system";

export { IconButton } from "@chakra-ui/button";
export type { ButtonProps, IconButtonProps } from "@chakra-ui/button";

/**
 * Chakra's `Button`, keeping its label in an element when it can show a spinner
 * (HUB-5629).
 *
 * When `isLoading` flips, Chakra moves the label into a wrapper, so React
 * removes the label's text node. Browser translation has by then swapped that
 * node for `<font>` elements without telling React, so the removal throws and
 * the whole page goes blank. An element is removed whole, translation inside it
 * or not; `display: contents` keeps the layout as it was.
 *
 * A button that never passes `isLoading` is left untouched. Pass it always or
 * never: going from omitted to passed changes the label's wrapper, which is the
 * same swap this guards against.
 */
export const Button = forwardRef<ButtonProps, "button">(
  ({ children, ...props }, ref) => (
    <ChakraButton ref={ref} {...props}>
      {props.isLoading === undefined ? (
        children
      ) : (
        <span style={{ display: "contents" }}>{children}</span>
      )}
    </ChakraButton>
  )
);

Button.displayName = "Button";
